// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requestQuoteFormStyles } from "@flip/App/Widgets/RequestQuote/RequestQuoteForm";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { css } from "styled-components";

requestQuoteFormStyles.emailGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

requestQuoteFormStyles.emailError = {
    color: "danger",
    size: 14,
    weight: fontConfig.weight.bold,
    css: css`
        margin-top: 4px;
    `,
};
